module.exports = __webpack_public_path__ + "static/img/simulate.8223740.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/simulate.png
// module id = fg4F
// module chunks = 3